@if (viewSystemStatus(); as systemStatus) {
    <div class="flex text-center justify-center items-center p-1 {{ systemStatus.classes }} font-semiBold h-[30px]">
        {{ systemStatus.text }}
    </div>
}
@if (!isLoading()) {
    <router-outlet />

    @if (socketData().withoutConnection) {
        <div
            class="bottom-[15px] fixed ml-[50%] translate-x-[-50%] flex flex-row items-center p-2 bg-brand-main-dark min-h-[33px] rounded-[4px] gap-2 overflow-hidden text-ellipsis w-[370px] max-w-full z-99999"
        >
            <span class="flex-1 truncate text-brand-main-lightest font-semiBold text-[11px] leading-[17px] uppercase">{{ socketData().text }}</span>

            @if (socketData().btnReconnect.enable) {
                <button
                    mat-ripple
                    (click)="socketData().actions.onReconnect()"
                    class="h-[25px] uppercase bg-transparent text-brand-main-lightest font-semiBold text-[11px] leading-[13px] px-[10px] border-solid border-brand-main-lightest border-[1px] rounded-sm hover:cursor-pointer"
                >
                    {{ socketData().btnReconnect.text }}
                </button>
            }

            @if (socketData().isReconnecting) {
                <mat-spinner diameter="16" strokeWidth="1" class="loader-lightest" />
            }
        </div>
    }
}

@if (viewReloadSystem(); as storedChanged) {
    <div class="absolute top-0 right-0 w-full h-full background-overlay z-[100] flex flex-row justify-center backdrop-blur-[3px]">
        <div
            class="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] p-7 flex flex-col bg-kiwid-surface max-w-[90%] w-[415px] rounded-[4px]"
            style="
                box-shadow:
                    0 2px 1px 1px rgba(0, 0, 0, 0.04),
                    0 1px 8px rgba(0, 0, 0, 0.08) !important;
            "
        >
            <img class="m-auto max-w-[80%]" src="./assets/images/system/placeholder-dialog-system.svg" />

            <h3 class="m-0 mt-3 font-typography-title-small text-neutral-darker text-center">
                {{ storedChanged.title }}
            </h3>

            <span class="text-[12px] mt-1 text-neutral-default text-center" [innerHTML]="storedChanged.description"></span>

            <k-button type="primary" class="mt-5 mx-auto" (click)="confirmReloadSystem()">
                {{ storedChanged.buttonConfirm }}
            </k-button>
        </div>
    </div>
}
